/**
 * Enum for form status.
 * @readonly
 * @enum {string}
 */
export const FormStatus = Object.freeze({
  Active: 'Active',
  Inactive: 'Inactive',
  Archived: 'Archived',
  Deleted: 'Deleted',
})
